var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            "label-position": "right",
            inline: "",
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "处理人" } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "", type: "text" },
                    model: {
                      value: _vm.userName,
                      callback: function($$v) {
                        _vm.userName = $$v
                      },
                      expression: "userName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "处理结果" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: {
                      placeholder: "请输入处理结果",
                      maxlength: "255",
                      type: "textarea",
                      autosize: { minRows: 3, maxRows: 3 }
                    },
                    model: {
                      value: _vm.childData.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "remark", $$v)
                      },
                      expression: "childData.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleFinish } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }